import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import ReactTable from "react-table";
import Button from "../Button";
import { Chip, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  margin: {
    marginRight: '20px',
    marginLeft: '20px'
  },
  center: {
    textAlign: 'center'
  }
}));

const weatherMoratoriumDefault = {
  page: 0,
  pageSize: 10,
  totalPages: 0,
  history: []
};

const WeatherMoratoriumHistory = (props) => {
  const { closePopup, fetchWeatherMoratoriumHistory, wmHistory, memberId } = props;
  const classes = useStyles();
  const [weatherMoratoriumHistory, setWeatherMoratoriumHistory] = useState(weatherMoratoriumDefault);

  const columns = [
    {
      Header: "Moratorium ID",
      accessor: "moratorium.id",
      style: { textAlign: 'center' },
    },
    { 
      Header: "TDSP",
      accessor: "moratorium.tdsp_name",
      style: { textAlign: 'center' },
    },
    {
      Header: "Counties",
      accessor: "moratorium.counties",
      Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>
        <Box display="flex" flexWrap="wrap" gap={0.5}>
          {value.map((tag, index) => (
            <Chip
              key={index}
              label={tag}
              size="small"
              style={{ margin: '1px' }}
              sx={{ fontSize: '0.75rem', height: 22, padding: '0 6px' }}
              color="primary"
            />
          ))}
        </Box>
      </div>)
    },
    {
      Header: 'Start Date',
      accessor: 'moratorium.start_date',
      style: { textAlign: 'center' },
    },
    {
      Header: 'End Date',
      accessor: 'moratorium.end_date',
      style: { textAlign: 'center' },
    },
    {
      Header: "Notice ID",
      accessor: "disconnect_notice.id",
      style: { textAlign: 'center' },
    },
    {
      Header: 'Amount Due',
      accessor: 'disconnect_notice.amount_due',
      style: { textAlign: 'center' },
    },
  ];

  const handlePageChange = (pageIndex) => {
    fetchWeatherMoratoriumHistory({
      member_id: memberId,
      page: pageIndex,
      limit: weatherMoratoriumHistory.pageSize
    });
  };

  const handlePageSizeChange = (newPageSize) => {
    setWeatherMoratoriumHistory(prev => ({
      ...prev,
      page: 0,
      pageSize: newPageSize
    }));
    fetchWeatherMoratoriumHistory({
      member_id: memberId,
      page: 0,
      limit: newPageSize
    });
  };

  useEffect(() => {
    fetchWeatherMoratoriumHistory({
      member_id: memberId,
      page: weatherMoratoriumHistory.page,
      limit: weatherMoratoriumHistory.pageSize
    });
  }, []);

  useEffect(() => {
    if (wmHistory && wmHistory.moratoriums) {
      setWeatherMoratoriumHistory((prevState) => ({
        page: parseInt(wmHistory.page || 0),
        pageSize: prevState.pageSize,
        totalPages: (Math.ceil(wmHistory.total / prevState.pageSize)) || 1,
        history: wmHistory.moratoriums
      }));
    }
  }, [wmHistory]);

  return (
    <div>
      <DialogTitle className={classes.margin}>
        Weather Moratorium History
      </DialogTitle>
      <DialogContent style={{ overflow: 'hidden' }}>
        <DialogContentText className={classes.margin}>
          {weatherMoratoriumHistory.history.length > 0 ? (
            <ReactTable
              data={weatherMoratoriumHistory.history}
              columns={columns}
              manual
              pages={weatherMoratoriumHistory.totalPages}
              page={weatherMoratoriumHistory.page}
              pageSize={weatherMoratoriumHistory.pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
            />
          ) : (
            <div className={classes.center}>No History to display</div>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.margin}>
        <Button
          onClick={closePopup}
          color="primary"
          variant="contained"
          style={{ float: "right", marginRight: 20, marginBottom: 10 }}
        >
          Close
        </Button>
      </DialogActions>
    </div>
  );
};

export default WeatherMoratoriumHistory;